import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, NgModule, OnDestroy, OnInit, Pipe, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { AppTokenHandler, HTTPStatus } from 'src/app/CommonService/app-token-handler';
import { DataService } from 'src/app/CommonService/data.service';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { FileUploadComponent } from 'src/app/Out-Of-Application/file-upload/file-upload.component';
import { CommonService } from 'src/app/Shared/common.service';
import { AddClauseComponent } from '../../add-clause/add-clause.component';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Observable, elementAt } from 'rxjs';
import { GTCRequisitionservice } from 'src/app/Shared/GTCRequisition.service';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AuditTrailComponent } from 'src/app/Out-Of-Application/audit-trail/audit-trail.component';
import { CustomValidators } from 'src/app/Shared/CustomValidators';
import saveAs from 'file-saver';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { forkJoin } from 'rxjs';
export class Task {
  name!: string;
  completed!: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}
export interface UserModel {
  requestId: string,
  GPN: string,
  UserName: string
}

export interface RiskProfile {
  value: string;
  label: string;
}

interface EmployeePartnerSelection {
  extraLabel?: string;
  label?: string;
  value?: string | EmployeePartnerSelection;
}

//2. Generic Mandatory Validation Message - INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
interface ValidationSummaryField {
  controlName: string;
  label: string;
}
@Component({
  selector: 'app-create-gtcrequisition',
  templateUrl: './create-gtcrequisition.component.html',
  styleUrls: ['./create-gtcrequisition.component.css']

})
// @HostListener('window:beforeunload')
export class CreateGTCRequisitionComponent implements OnInit {


  displayedColumns: string[] =
    ['ClauseNo', 'PaceID', 'EntityName', 'CreatedOn', 'Delete'];
  task: Task = {
    name: 'Limitation of Liability',
    completed: false,
    color: 'primary',
    subtasks: [
      { name: 'Primary', completed: false, color: 'primary' },
      { name: 'Primary', completed: false, color: 'primary' },
      { name: 'Primary', completed: false, color: 'primary' },
    ],
  };
  riskProfiles: RiskProfile[] = [
    { value: '1', label: 'Low' },
    { value: '2', label: 'Moderate' },
    { value: '3', label: 'High' },
  ];
  @ViewChild(MatTable, { static: false }) table!: MatTable<any>
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  allComplete: boolean = false;
  selectedTabIndex: any;
  GTCForm!: FormGroup;
  entityNameList!: any;
  AttachDict: any;
  IsTableShown: any;
  IsDisableExpProp: any;
  filterargs = { IsActive: true };
  ClauseDetailsList: any;
  public datas: UserModel = { requestId: '', GPN: '', UserName: '' };
  data!: MatTableDataSource<any[]>;
  ClauseViewList: ClauseViewList[] = [];
  savedClauseViewList: ClauseViewList[] = [];
  modifiedClauseViewList: ClauseViewList[] = [];
  isTQCommentsModified: boolean = false;
  LimOfLiablityList!: any;
  ConfidentialityList!: any;

  IndemnityList!: any;
  paceList!: any;
  ManagerList!: any;
  PartnerList!: any;
  clauseMasterDetailsList!: ClauseMasterDetails[];
  IsFormEditable!: boolean;
  ShowButtons: any
  checkNumber: any;
  isEven: any;
  IsReturnRequest: any;
  IsTQLComments: any;
  IsLoadingResults: any;

  IsContractualScreenDisabled = false;
  IsBusinessCaseReason: boolean = false;
  IsScopeScreenDisabled = false;
  IsExceptionalRequired: any;
  IsChangesInPast: any;
  IsGTCProposed: boolean = false;
  IsKeyTermsScreenDisabled = false;
  IsProposedScreenDisabled = false;
  IsExceptionalScreenDisabled = false;
  IsAddCaluseButtonDisable = false;
  ToolTipDisabaleHoverMessage: any;
  SelectedExceptionalDetails: string[] = new Array();
  IsRiskInvlovedTextBoxShown = false;
  // for expecttional details checkbox
  IsOthers!: any;
  IsDual!: any;
  IsReciprocalIndemnity!: any;
  IsIncreaseConfidentiality!: any;
  IsAcptForChangesInPast!: any;
  IsPerpetualConfidentiality!: any;
  IsConfidentiality!: any;
  IsConsentFalse: boolean = false;
  IsReciprocalLimitation!: any;
  IsCappingOfIndemnity!: any;
  IsDeletionIndemnity!: any;
  IsIndemnity!: any;
  IsCopyRedirected: any;
  RejectReturnReason: any;
  TQComments: any;
  SendTOTQLReson: any;
  IsConsultedForTQApproval!: any;
  ScreenId = 1;
  Approve = 4;
  Reject = 5;
  Return = 6;
  PartiallyApprove = 7;
  InitateRequest = 8;
  PendingWithTQL = 3;
  SelectedAction!: 0;
  IsAddCluaseButtonShow: any;
  IsMutualLiability!: any;
  IsUnlimitedLiability!: any;
  FormStatusName!: string;
  IsDirectDamages!: any;
  IsIndirectDamages!: any;
  IsLimitationLib!: any;
  RecordStatus: any;
  RequestEntityId: any;
  GTCNo!: string;
  IsAddEngPartnerRequired: any;
  // private hubConnection!: signalR.HubConnection
  IsShownSubmitAndSaveButton: boolean = false;
  IsShowattachGCOAttach: boolean = false;
  ShowApprovalButtons: any;
  tenureDigitLimitExceeded = false;                       //12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
  expectedFeesDigitLimitExceeded = false;                  //12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
  expectedFeesTaxServicesDigitLimitExceeded = false;       //12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
  //2. Generic Mandatory Validation Message - INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
  showValidationSummary = false;
  readonly validationSummaryFields: Record<string, ValidationSummaryField[]> = {
    basic: [
      { controlName: 'FirmId', label: 'A1. Contracting Member Firm' },
      { controlName: 'PaceID', label: 'A2. PACE ID' },
      { controlName: 'SSL', label: 'A3. Sub-Service Line (SSL)' },
      { controlName: 'Location', label: 'A4. Engagement Partner (EP) Location' },
      { controlName: 'ClientName', label: 'A5. Client Name' },
      { controlName: 'EngPartnerName', label: 'A6. EP Name' },
      { controlName: 'IsPartnerNameRequired', label: 'A7. Is the EP signing the Engagement Agreement (EA) different from the EP listed on PACE?' },
      { controlName: 'EngPartnerReqName', label: 'A7.1. EP Name per EA' },
      { controlName: 'EngManagerName', label: 'A8. Engagement Manager (EM) Name' },
      { controlName: 'IsIndependenceRestrictedClient', label: 'A9. Is this an Independence restricted client?' },
      { controlName: 'IsG360Client', label: 'A10. Is this a G360 Account?' },
      { controlName: 'IsClientNew', label: 'A11. Is this a new client or existing client?' }
    ],
    contractual: [
      { controlName: 'IsGTCProposedForEAOrMSA', label: 'B1. Are these changes in the GTCs proposed in a standalone Engagement Agreement (EA) or Master Service Agreement (MSA)?' },
      { controlName: 'TaxExclusiveForMSA', label: 'B1.1. Please confirm if it is a TAX exclusive MSA or does this MSA cover other service lines as well?' },
      { controlName: 'TenureInMonths', label: 'B2. What is the tenure (in months) for this agreement?' },
      { controlName: 'ScopeOfWorkInBrief', label: 'B3. Explain the scope of work in brief below.' },
      { controlName: 'ScopeOfWorkInBriefAttachment', label: 'B3. Attach the draft scope for reference.' },
      { controlName: 'RiskProfileEngagement', label: 'B4. What is the risk profile of this engagement?' },
      { controlName: 'DetailsOfRiskInvolvedInEng', label: 'B4.1. Explain the risk involved in this engagement.' },
      { controlName: 'ExpectedFeesFromClient', label: 'B5. What is the expected fees (in INR) from the client under this agreement for Tax services?' },
      { controlName: 'ExpectedFeesFromClientForTaxServices', label: 'B6. What is the expected fees (in INR) from this client for Tax services over a 12-month period?' }
    ],
    proposedChanges: [
      { controlName: 'PushBackDone', label: 'C1. What is the level of push back done for these proposed changes?' },
      { controlName: 'PushBackAttachment', label: 'C1.1. Please attach evidence of pushback done with the client.' },
      { controlName: 'IsAcceptanceForChangesInPast', label: 'C2. Have we accepted the exact changes in the past?' },
      { controlName: 'ApprDtlForTaxQualityLOL', label: 'C2.1. Provide the latest approvals obtained from Tax Quality team and other LOL grid approvers.' },
      { controlName: 'ApprDtlForTaxQualityLOLAttachment', label: 'C2.1. Attach the latest approvals obtained from Tax Quality team and other LOL grid approvers.' },
      { controlName: 'IsGTCApprovedGCO', label: 'Are the changes in the standard GTCs approved and reviewed by the GCO?' },
      { controlName: 'AttachGCOAttachment', label: 'Attach GCO approval email/comments on the proposed changes.' },
      { controlName: 'BusinessCaseAcceptanceReason', label: 'Provide the business case for accepting the proposed changes.' }
    ],
    exceptionalApproval: [
      { controlName: 'IsExceptionalApprovalRequired', label: 'D1. Is this an exceptional approval?' },
      { controlName: 'ExceptionalDetails', label: 'D2. Exceptional approval details.' }
    ]
  };
  //2. Generic Mandatory Validation Message - INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
  EmpPartnerList: any;
  partnerCache = new Map<string, any[]>();
  selectedPartnerGPN: any;
  SSLList: any;
  LocationList: any;
  clientDetails: ClientDetails = new ClientDetails();
  constructor(private fb: FormBuilder,
    private ref: ChangeDetectorRef,
    private _dataService: DataService,
    private status: HTTPStatus,
    private _router: Router,
    public global: GlobalVariables,
    private activatedRoute: ActivatedRoute,
    private _gtcService: GTCRequisitionservice,
    private customValidators: CustomValidators,
    // private requestService:RequestService,
    private _dialog: MatDialog, private _commonService: CommonService) {
    this.GTCForm = this.fb.group({
      GTCID: [],
      RequestEntityId: [''],
      RecordStatus: [1],
      StatusName: [''],
      FirmId: [null, Validators.required],
      FirmName: [''],
      EngPartnerName: ['', Validators.required],
      SSL: ['', Validators.required],
      Location: ['', Validators.required],
      ClientName: ['', Validators.required],
      PaceID: ['', Validators.required],
      IsIndependenceRestrictedClient: [null, Validators.required],
      IsG360Client: [null, Validators.required],
      EngManagerName: ['', Validators.required],
      IsClientNew: [null, Validators.required],
      PushBackDone: ['', [Validators.required, this.customValidators.nameValidator]],
      AttachmentList: [],
      PushBackAttachment: ['', Validators.required],
      IsAcceptanceForChangesInPast: [null],
      ApprDtlForTaxQualityLOL: [],
      ApprDtlForTaxQualityLOLAttachment: [''],
      IsGTCApprovedGCO: [null, Validators.required],
      AttachGCOAttachment: [''],
      BusinessCaseAcceptanceReason: ['', [Validators.required, this.customValidators.nameValidator]],
      IsGTCProposedForEAOrMSA: [null, Validators.required],
      TaxExclusiveForMSA: [null],
      TenureInMonths: [null, [Validators.required, Validators.pattern(/^\d{1,8}(\.\d{1,2})?$/)]],   
      ScopeOfWorkInBrief: [null, [Validators.required, this.customValidators.nameValidator]],
      ScopeOfWorkInBriefAttachment: ['', Validators.required],
      RiskProfileEngagement: [null],
      DetailsOfRiskInvolvedInEng: [''],
      ExpectedFeesFromClient: [null, [Validators.required, Validators.pattern(/^\d{1,18}(\.\d{1,2})?$/)]],
      ExpectedFeesFromClientForTaxServices: [null],
      LimitationOfLibality: [null],
      Confidentiality: [null],
      Indemnity: [null],
      IsExceptionalApprovalRequired: [null],
      ExceptionalCategory: [],
      ExceptionalDetails: [],
      ExceptionalApprovals: [],
      ClauseViewList: [],
      ActionTakenByTQL: [''],
      ClientID: [''],
      EngPartnerGPN: [''],
      EngManagerGPN: [''],
      TQComments: [''],
      IsConsultedForTQApproval: [null],
      ApproveWithTQCommentsAttachment: [''],
      TQApproverAttachment: [''],
      IsPartnerNameRequired: [null, Validators.required],
      EngPartnerReqName: [''],
      RequiredEmpPartnerGPN: [''],
      PaceIdMessage: [''],

    });
    console.log('[A7.1 Trace] Form initialized:', {
      EngPartnerReqName: this.getFormControls('EngPartnerReqName').value,
      RequiredEmpPartnerGPN: this.getFormControls('RequiredEmpPartnerGPN').value
    });
  }
  //Lineno(253, 258 ,GTCForm) 12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
  // ngOnDestroy(): void {
  //   this.requestService.hubConnection.invoke("RequestClosed", this.datas).catch(error => console.error(error));

  // }
  ngOnInit() {
    this.IsAddCluaseButtonShow = true;
    this.IsReturnRequest = false;
    this.ShowButtons = false;
    this.IsTQLComments = false;
    this.AttachDict = [];
    this.IsDisableExpProp = false;
    this.ClauseDetailsList = [];
    this.ShowApprovalButtons = false;
    this.IsExceptionalRequired = false;
    this.IsAcptForChangesInPast = false;
    this.IsChangesInPast = false;
    // this.ClauseViewList = [];
    this.FormStatusName = 'New ';
    this.RequestEntityId = this.activatedRoute.snapshot.paramMap.get('ID');
    let value = this.activatedRoute.snapshot.paramMap.get('Value');
    //#DropDown binding starts

    this.bindDropDowns();




    this.IsFormEditable = false;
    if (!this.checkValueIsNullOrEmptyOrUndefined(this.RequestEntityId)) {
      this.global.auditTrailId = this.RequestEntityId;
      this.global.auditTrailClass = 'GTCTaxRequest';
      this.GTCForm.controls['RequestEntityId'].setValue(this.RequestEntityId);
      if (value == 'true') {
        this.IsCopyRedirected = true

      }
      else {
        this.IsCopyRedirected = false

      }
      this.GetGTCRequestById(this.RequestEntityId, this.IsCopyRedirected);


    }
    else {
      this.RecordStatus = 1
      this.IsFormEditable = true;
      this.global.auditTrailId = this.global.auditTrailClass = '';
    }

  }
  bindDropDowns() {
    this.IsLoadingResults = true;
    forkJoin({
      firms: this._commonService.BindDropDown('FirmType'),
      ssl: this._commonService.BindDropDown('SSL'),
      location: this._commonService.BindDropDown('Location')
    }).subscribe({
      next: ({ firms, ssl, location }) => {
        this.entityNameList = firms;
        this.SSLList = ssl;
        this.LocationList = location;
        if (this.checkValueIsNullOrEmptyOrUndefined(this.RequestEntityId)) {
          this.IsLoadingResults = false;

        }
        this.ref.detectChanges(); // Manually trigger change detection
      },
      error: (error) => {
        if (this.checkValueIsNullOrEmptyOrUndefined(this.RequestEntityId)) {
          this.IsLoadingResults = false;

        }
        this.ref.detectChanges(); // Manually trigger change detection

      }
    });

  }

  getPartnerDetails($event: any) {
    this.getFormControls('EngPartnerGPN').setValue($event.EmpGPN);
  }
  SearchPartnerName($event: any) {
    this._commonService.BindDropDownForEmpPartnerValues($event.query).
      subscribe((result: any) => {
        this.PartnerList = result.map((a: { EmpName: any; EmpGPN: any; }) => ({
          EmpName: a.EmpName,
          EmpGPN: a.EmpGPN
        }));
      });
  }

  ResetPartnerDetails() {

  }

  ResetManagerDetails() {
  }
  getManagerDetails($event: any) {
    this.getFormControls('EngManagerGPN').setValue($event.EmpGPN);
  }
  SearchManagerName($event: AutoCompleteCompleteEvent) {
    this._commonService.BindDropDownForEmpManagerValues($event.query).
      subscribe((result: any) => {
        this.ManagerList = result.map((a: { EmpName: any; EmpGPN: any; }) => ({
          EmpName: a.EmpName,
          EmpGPN: a.EmpGPN
        }));
      });
  }
  OnEPSigningRequired(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event.value)) {
      if (event.value == 1) { //yes
        this.IsAddEngPartnerRequired = true;
        this.getFormControls('EngPartnerReqName').setValidators([Validators.required]);
        this.getFormControls('EngPartnerReqName').updateValueAndValidity();

      }
      else if (event.value == 2) { //no
        this.getFormControls('EngPartnerReqName')?.reset();
        this.getFormControls('EngPartnerReqName').clearValidators();
        this.getFormControls('EngPartnerReqName').updateValueAndValidity();
        this.getFormControls('RequiredEmpPartnerGPN')?.reset();
        this.getFormControls('RequiredEmpPartnerGPN').clearValidators();
        this.getFormControls('RequiredEmpPartnerGPN').updateValueAndValidity();
        this.IsAddEngPartnerRequired = false;

      }
      else {
        return;
      }
    }
  }
  OnExceptionalApprovalChange(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event)) {
      if (event.value == 1) //yes
      {

        this.getFormControls('ExceptionalDetails').setValidators([Validators.required, this.customValidators.nameValidator]);
        this.getFormControls('ExceptionalDetails').updateValueAndValidity();
        this.IsDisableExpProp = false;
      }
      else { //no
        this.IsDisableExpProp = true;

        this.IsIndirectDamages = false;
        this.IsDirectDamages = false;
        this.IsUnlimitedLiability = false;
        this.IsMutualLiability = false;
        this.IsDeletionIndemnity = false;
        this.IsCappingOfIndemnity = false;
        this.IsReciprocalLimitation = false;
        this.IsConfidentiality = false;
        this.IsPerpetualConfidentiality = false;
        this.IsIncreaseConfidentiality = false;
        this.IsDual = false;
        this.IsOthers = false;

        this.getFormControls('ExceptionalDetails')?.reset();
        this.getFormControls('ExceptionalDetails').clearValidators();
        this.getFormControls('ExceptionalDetails').updateValueAndValidity();
        this.ref.detectChanges(); // Manually trigger change detection


      }
    }
  }
  OnCopyAndCreateNewRequest() {

    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate(['home/createRequistion/new/', this.RequestEntityId, true]);
    });


  }
  //   canDeactivate(): Observable<boolean> | boolean {
  //     this.requestService.hubConnection.invoke("RequestClosed", this.datas).catch(error => console.error(error));
  //     return true;
  // }
  onEntityChange(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event.value)) {
      let firmName = this.entityNameList.find((s: { value: any; }) => s.value == event.value).label;
      this.GTCForm.controls['FirmName'].setValue(firmName);
      this.getFormControls('EngPartnerReqName').reset();
    }

  }
  onRiskInvlovedClick(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event.value)) {
      if (event.value == '3' || event.value == '2') {
        this.IsRiskInvlovedTextBoxShown = true;
        // this.getFormControls('DetailsOfRiskInvolvedInEng').setValidators([Validators.required,this.customValidators.nameValidator]);
        // this.getFormControls('DetailsOfRiskInvolvedInEng').updateValueAndValidity();
      }
      else {
        this.getFormControls('DetailsOfRiskInvolvedInEng')?.reset();
        this.IsRiskInvlovedTextBoxShown = false;
        // this.getFormControls('DetailsOfRiskInvolvedInEng').clearValidators();
        // this.getFormControls('DetailsOfRiskInvolvedInEng').updateValueAndValidity();
      }
    }
  }
  //12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
  restrictNumericInput(event: Event, controlName: string, maxDigits: number): void {
    const input = event.target as HTMLInputElement;
    const numericValue = input.value.replace(/\D/g, '');
    const limitExceeded = numericValue.length > maxDigits;
    const limitedValue = numericValue.slice(0, maxDigits);

    input.value = limitedValue;
    this.getFormControls(controlName).setValue(limitedValue);

    if (controlName === 'TenureInMonths') {
      this.tenureDigitLimitExceeded = limitExceeded;
    } else if (controlName === 'ExpectedFeesFromClient') {
      this.expectedFeesDigitLimitExceeded = limitExceeded;
    } else if (controlName === 'ExpectedFeesFromClientForTaxServices') {
      this.expectedFeesTaxServicesDigitLimitExceeded = limitExceeded;
    }
  }
  preventInvalidNumericInput(event: InputEvent, controlName: string, maxDigits: number): void {
    if (!event.inputType.startsWith('insert')) {
      return;
    }

    const input = event.target as HTMLInputElement;
    const enteredValue = event.data || '';
    const selectionStart = input.selectionStart ?? input.value.length;
    const selectionEnd = input.selectionEnd ?? selectionStart;
    const nextValue = input.value.slice(0, selectionStart) + enteredValue + input.value.slice(selectionEnd);
    const isInvalid = !/^\d*$/.test(enteredValue) || nextValue.length > maxDigits;

    if (controlName === 'TenureInMonths') {
      this.tenureDigitLimitExceeded = isInvalid;
    } else if (controlName === 'ExpectedFeesFromClient') {
      this.expectedFeesDigitLimitExceeded = isInvalid;
    } else if (controlName === 'ExpectedFeesFromClientForTaxServices') {
      this.expectedFeesTaxServicesDigitLimitExceeded = isInvalid;
    }

    if (isInvalid) {
      event.preventDefault();
    }
  }
  //12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
  openAuditTrailDialog() {
    this._dialog.open(AuditTrailComponent,
      {
        width: '1200px',
        maxWidth: '95vw',
        panelClass: 'audit-trail-dialog',
        disableClose: true
      });
  }
  onTabChanged(event: any) {
    //   if(event.index == 5){
    //     this._dataService.get('TaxGTC/GetClauseMasterDetails', this.GTCForm.controls['FirmId'].value).subscribe((data:any) => {
    //       // let rentObject = data.map((ct: any) => this.mapRent(ct));
    //     if(!this.checkValueIsNullOrEmptyOrUndefined(data)){
    //       this.clauseMasterDetailsList = Object.assign(new ClauseMasterDetails(), data);
    //     }
    //   });
    // }
  }
  toggle(event: MatCheckboxChange) {
    if (event.checked) {
      this.SelectedExceptionalDetails.push(event.source.value);
    }
    else {
      this.SelectedExceptionalDetails.forEach((element, index) => {
        if (element == event.source.value) this.SelectedExceptionalDetails.splice(index, 1);
      });
    }
    var d = this.SelectedExceptionalDetails.toString();
  }

  onGTCProposedSelected(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event.value)) {
      if (event.value == 2) {
        this.IsGTCProposed = true;
        this.getFormControls('TaxExclusiveForMSA').setValidators([Validators.required]);
        this.getFormControls('TaxExclusiveForMSA').updateValueAndValidity();
        this.getFormControls('ExpectedFeesFromClientForTaxServices').setValidators([Validators.required, Validators.pattern(/^\d{1,10}$/)]);  //12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
        this.getFormControls('ExpectedFeesFromClientForTaxServices').updateValueAndValidity();
      }
      else if (event.value == 1) {
        this.getFormControls('TaxExclusiveForMSA')?.reset();
        this.getFormControls('ExpectedFeesFromClientForTaxServices')?.reset();
        this.IsGTCProposed = false;
        this.getFormControls('TaxExclusiveForMSA').clearValidators();
        this.getFormControls('TaxExclusiveForMSA').updateValueAndValidity();
        this.getFormControls('ExpectedFeesFromClientForTaxServices').clearValidators();
        this.getFormControls('ExpectedFeesFromClientForTaxServices').updateValueAndValidity();
      }
      else {
        return;
      }
    }
  }

  EnableAndAddValidatationsFileds() {
    this.getFormControls('BusinessCaseAcceptanceReason').setValidators([Validators.required, this.customValidators.nameValidator]);
    this.getFormControls('AttachGCOAttachment').setValidators([Validators.required]);
    this.getFormControls('ScopeOfWorkInBriefAttachment').setValidators([Validators.required]);
    this.getFormControls('IsGTCProposedForEAOrMSA').setValidators([Validators.required]);
    // this.getFormControls('TaxExclusiveForMSA').setValidators([Validators.required ,this.customValidators.nameValidator]);
    this.getFormControls('TenureInMonths').setValidators([Validators.required, Validators.pattern(/^\d{1,3}$/)]); //12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
    this.getFormControls('ScopeOfWorkInBrief').setValidators([Validators.required, this.customValidators.nameValidator]);
    // this.getFormControls('RiskProfileEngagement').setValidators([Validators.required]);
    this.getFormControls('ExpectedFeesFromClient').setValidators([Validators.required, Validators.pattern(/^\d{1,10}$/)]);  //12. Numeric Field Handling Issue - InTaxGTc - Changes By Rehan
    // this.getFormControls('ExpectedFeesFromClientForTaxServices').setValidators([Validators.required]);
    // this.getFormControls('LimitationOfLibality').setValidators([Validators.required]);
    // this.getFormControls('Confidentiality').setValidators([Validators.required]);
    // this.getFormControls('Indemnity').setValidators([Validators.required]);
    // this.getFormControls('DetailsOfRiskInvolvedInEng').setValidators([Validators.required,this.customValidators.nameValidator]);
    this.getFormControls('BusinessCaseAcceptanceReason').updateValueAndValidity();
    this.getFormControls('AttachGCOAttachment').updateValueAndValidity();
    this.getFormControls('IsGTCProposedForEAOrMSA').updateValueAndValidity();
    // this.getFormControls('TaxExclusiveForMSA').updateValueAndValidity();
    this.getFormControls('TenureInMonths').updateValueAndValidity();
    this.getFormControls('ScopeOfWorkInBrief').updateValueAndValidity();
    // this.getFormControls('RiskProfileEngagement').updateValueAndValidity();
    this.getFormControls('ExpectedFeesFromClient').updateValueAndValidity();
    // this.getFormControls('ExpectedFeesFromClientForTaxServices').updateValueAndValidity();
    // this.getFormControls('LimitationOfLibality').updateValueAndValidity();
    // this.getFormControls('Confidentiality').updateValueAndValidity();
    // this.getFormControls('Indemnity').updateValueAndValidity();
    this.getFormControls('ScopeOfWorkInBriefAttachment').updateValueAndValidity();
    // this.getFormControls('DetailsOfRiskInvolvedInEng').updateValueAndValidity();
    this.IsContractualScreenDisabled = false;
    this.IsScopeScreenDisabled = false;
    this.IsKeyTermsScreenDisabled = false;
    this.IsProposedScreenDisabled = false;
    this.IsBusinessCaseReason = false;
    this.GTCForm.controls['BusinessCaseAcceptanceReason'].enable();


  }

  DisableAndRemoveValidatationsFileds() {

    this.ClauseViewList = [];
    this.IsGTCProposed = false;
    this.IsRiskInvlovedTextBoxShown = false;
    // this.IsContractualScreenDisabled = true;
    this.IsScopeScreenDisabled = true;
    this.IsBusinessCaseReason = true;
    this.IsKeyTermsScreenDisabled = true;
    // this.IsProposedScreenDisabled = true;
    this.getFormControls('BusinessCaseAcceptanceReason')?.reset();
    this.GTCForm.controls['BusinessCaseAcceptanceReason'].disable();
    this.removeAttachment('AttachGCOAttachment');
    this.removeAttachment('ScopeOfWorkInBriefAttachment');
    this.getFormControls('IsGTCProposedForEAOrMSA')?.reset();
    this.getFormControls('TaxExclusiveForMSA')?.reset();
    this.getFormControls('TenureInMonths')?.reset();
    this.getFormControls('ScopeOfWorkInBrief')?.reset();
    this.getFormControls('RiskProfileEngagement')?.reset();
    this.getFormControls('DetailsOfRiskInvolvedInEng')?.reset();
    this.getFormControls('ExpectedFeesFromClient')?.reset();
    this.getFormControls('ExpectedFeesFromClientForTaxServices')?.reset();
    // this.getFormControls('LimitationOfLibality')?.reset();
    // this.getFormControls('Confidentiality')?.reset();
    // this.getFormControls('Indemnity')?.reset();
    this.getFormControls('AttachGCOAttachment').clearValidators();
    this.getFormControls('DetailsOfRiskInvolvedInEng').clearValidators();
    this.getFormControls('ScopeOfWorkInBriefAttachment').clearValidators();
    this.getFormControls('BusinessCaseAcceptanceReason').clearValidators();
    this.getFormControls('IsGTCProposedForEAOrMSA').clearValidators();
    this.getFormControls('TaxExclusiveForMSA').clearValidators();
    this.getFormControls('TenureInMonths').clearValidators();
    this.getFormControls('ScopeOfWorkInBrief').clearValidators();
    this.getFormControls('RiskProfileEngagement').clearValidators();
    this.getFormControls('ExpectedFeesFromClient').clearValidators();
    this.getFormControls('ExpectedFeesFromClientForTaxServices').clearValidators();
    // this.getFormControls('LimitationOfLibality').clearValidators();
    // this.getFormControls('Confidentiality').clearValidators();
    // this.getFormControls('Indemnity').clearValidators();
    this.getFormControls('BusinessCaseAcceptanceReason').updateValueAndValidity();
    this.getFormControls('IsGTCProposedForEAOrMSA').updateValueAndValidity();
    this.getFormControls('TaxExclusiveForMSA').updateValueAndValidity();
    this.getFormControls('TenureInMonths').updateValueAndValidity();
    this.getFormControls('ScopeOfWorkInBrief').updateValueAndValidity();
    this.getFormControls('RiskProfileEngagement').updateValueAndValidity();
    this.getFormControls('ExpectedFeesFromClient').updateValueAndValidity();
    this.getFormControls('ExpectedFeesFromClientForTaxServices').updateValueAndValidity();
    // this.getFormControls('LimitationOfLibality').updateValueAndValidity();
    // this.getFormControls('Confidentiality').updateValueAndValidity();
    // this.getFormControls('Indemnity').updateValueAndValidity();
    this.getFormControls('AttachGCOAttachment').updateValueAndValidity();
    this.getFormControls('DetailsOfRiskInvolvedInEng').updateValueAndValidity();
    this.getFormControls('ScopeOfWorkInBriefAttachment').updateValueAndValidity();
  }
  //5. Mandatory Validation Not Triggered // INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
  private updateAttachGCOAttachmentValidation(): void {
    const attachGcoControl = this.getFormControls('AttachGCOAttachment');
    const shouldRequireAttachment = this.IsShowattachGCOAttach && !this.IsBusinessCaseReason;

    if (shouldRequireAttachment) {
      attachGcoControl.setValidators([Validators.required]);
    } else {
      attachGcoControl.clearValidators();
    }

    attachGcoControl.updateValueAndValidity();
  }
  //5. Mandatory Validation Not Triggered // INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
  onAcceptanceClick(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event.value)) {
      if (event.value == '2') {
        this.IsShownSubmitAndSaveButton = false;
        this.IsShowattachGCOAttach = false;
        this.IsConsentFalse = true
        if (confirm("Please consult with GCO team and share their review comments on the proposed edits.")) {
          //this.DisableAndRemoveValidatationsFileds();
          this.IsAddCaluseButtonDisable = true
        }
      } else {
        this.IsShowattachGCOAttach = true;
        this.IsConsentFalse = false
        this.IsShownSubmitAndSaveButton = true;
        this.IsAddCaluseButtonDisable = false;
        //this.EnableAndAddValidatationsFileds();
      }
      //5. Mandatory Validation Not Triggered // INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
      this.updateAttachGCOAttachmentValidation();
      //5. Mandatory Validation Not Triggered // INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
    }
  }
  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
  }
  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
  private resetLoadingState(): void {
    this.IsLoadingResults = false;
    this.status.setHttpStatus(false);
  }
   //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan

  private validateApprovalActionPrerequisites(): boolean {
    var clauseRange = '';

    this.ClauseViewList.forEach((element: any) => {
      if (!this.checkValueIsNullOrEmptyOrUndefined(element.ClauseDetailsList)) {
        element.ClauseDetailsList.forEach((elementTwo: any) => {
          if (!this.checkValueIsNullOrEmptyOrUndefined(elementTwo.ClauseRadioType)
            && (elementTwo.ClauseRadioType == 1 || elementTwo.ClauseRadioType == 2 || elementTwo.ClauseRadioType == 4)
            && this.checkValueIsNullOrEmptyOrUndefined(elementTwo.ClauseStatus)) {
            clauseRange += elementTwo.ClauseNumber + ',';
          }
        });
      }
    });

    if (!this.checkValueIsNullOrEmptyOrUndefined(clauseRange)) {
      alert("No action has been taken on the following clauses:- " + clauseRange + " Please take at least one action before proceeding further.")
      return false;
    }

    var expe = this.GTCForm.controls['IsExceptionalApprovalRequired'].value;
    var expeDetails = this.GTCForm.controls['ExceptionalDetails'].value;

    if (!this.checkValueIsNullOrEmptyOrUndefined(expe)) {
      if (expe == 1 && this.checkValueIsNullOrEmptyOrUndefined(expeDetails)) {
        // D2 already receives its required validator when D1 is Yes; expose that existing
        // validation state without changing the exceptional-approval business rule.
        this.getFormControls('ExceptionalDetails').markAsTouched({ onlySelf: true });
        alert('Please provide the Exceptional Details before submitting.');
        return false;
      }
    }
    else {
      // Mark only D1 as touched so its existing required-field message is shown with the alert.
      // This preserves the current clause-first validation order and approval action behavior.
      this.getFormControls('IsExceptionalApprovalRequired').markAsTouched({ onlySelf: true });
      alert('Please provide the Exceptional Details before submitting.');
      return false;
    }

    return true;
  }

  ChangeApprovalStatus(actionId: any) {
    this.IsLoadingResults = true;

    var message = '';
    var rejAndPushClauseRange = '';
    this.SelectedAction = actionId;
    this.ClauseViewList.forEach((element: any) => {
      if (!this.checkValueIsNullOrEmptyOrUndefined(element.ClauseDetailsList)) {


        element.ClauseDetailsList.forEach((elementTwo: any) => {
          if ((elementTwo.ClauseRadioType == 1 || elementTwo.ClauseRadioType == 2 || elementTwo.ClauseRadioType == 4)
            && !this.checkValueIsNullOrEmptyOrUndefined(elementTwo.ClauseStatus) && (elementTwo.ClauseStatus == 2 || elementTwo.ClauseStatus == 3)) {


            rejAndPushClauseRange += elementTwo.ClauseNumber + ',';

          }


        });
      }

    });

    if (actionId == this.Approve) {
      if (!this.checkValueIsNullOrEmptyOrUndefined(rejAndPushClauseRange)) {
        alert("Following Clauses:- " + rejAndPushClauseRange + " are PushBacked or Rejected ,Please reject or return the request")
        //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
        this.resetLoadingState();
        //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
        return;
      }
    }
    if (actionId === this.Approve) {


      this.RejectReturnReason = null;
      this.RecordStatus = 4
      message = 'Are you sure you want to approve the request?';

    }
    else if (actionId === this.Reject) {
      this.RecordStatus = 5
      message = 'Are you sure you want to reject the request?';
    }
    else if (actionId === this.Return) {
      this.RecordStatus = 6
      message = 'Are you sure you want to return the request?';
    }
    else if (actionId === this.PartiallyApprove) {
      this.RecordStatus = 7
      message = 'Are you sure you want to Partially  approve the request?';
    }
    else if (actionId === this.PendingWithTQL) {
      this.RecordStatus = 3
      message = 'Are you sure you want to send this request to TQL?';
    }
    else {
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
      //this.IsLoadingResults = false;
      this.resetLoadingState();
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
    }
    if ((actionId === this.Approve ||
      actionId === this.PartiallyApprove ||
      actionId === this.Return || actionId === this.Reject || actionId === this.PendingWithTQL)
      && (this.checkValueIsNullOrEmptyOrUndefined(this.TQComments)
        || this.checkValueIsNullOrEmptyOrUndefined(this.IsConsultedForTQApproval))) {
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
      //this.IsLoadingResults = false;
      this.resetLoadingState();
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan

      alert('Please fill in all TQ comment details before proceeding.');

      return;
    }
    this.IsLoadingResults = true;

    if (!confirm(message)) {
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
      this.resetLoadingState();
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
      return;
    }
    // if(!this.checkValueIsNullOrEmptyOrUndefined(this.getFormControls('PaceIdMessage').value)){


    //   const confirmation = confirm(this.getFormControls('PaceIdMessage').value);
    //   if (confirmation) {
    //   } else {
    //     return;
    //   }
    // }
    this._dialog.closeAll();

    var approvalChange = {
      "RecordId": this.RequestEntityId,
      "CurrentStatus": this.RecordStatus,
      "Remarks": this.RejectReturnReason,
      "TQComments": this.TQComments,
      "IsConsultedForTQApproval": this.IsConsultedForTQApproval,
      "AttachmentList": this.AttachDict,
      "IsExceptionalApprovalRequired": this.GTCForm.controls['IsExceptionalApprovalRequired'].value,
      "ExceptionalDetails": this.GTCForm.controls['ExceptionalDetails'].value,
      "ExceptionalCategory": this.SelectedExceptionalDetails.toString().length > 0 ? this.SelectedExceptionalDetails.toString() : this.getFormControls('ExceptionalCategory').value,
      "ClauseList": this.ClauseViewList
    };
    this._gtcService.ChangeApprovalStatus(approvalChange).subscribe((data: any) => {
      alert(data.RequestMessage);
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
      this.resetLoadingState();
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
      if (data.RequestIsSuccess) {
        // Clear TQComments after successful save for TQ Approver
        this.ClauseViewList.forEach((element: any) => {
          if (element.ClauseDetailsList) {
            element.ClauseDetailsList.forEach((clause: any) => {
              clause.TQComments = '';
            });
          }
        });
        // this.hubConnection.invoke("RequestClosed", this.datas).catch(error => console.error(error));

        window.history.back();
      }
    }, (error: any) => {
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
      this.resetLoadingState();
      //17.	Issue: Loading screen persists when Reject action is cancelled -- INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
    });

  }


  // onWindowClose() {
  //     // Call the method
  //     this.hubConnection.invoke("RequestClosed", this.datas).catch(error => console.error(error));
  // }

  OnInputChange(control: any, event: any) {
    if (this.global.containsSpecialChars(event.data)) {
      this.getFormControls(control)?.reset();
      alert("Please enter valid input")
      return;
    }

  }
  onConstrutedChange(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event.value)) {

      if (event.value == '1') {
        this.IsConsultedForTQApproval = '1';
      }
      else {
        this.IsConsultedForTQApproval = '2';
      }
    }

  }

  isValidPaceIdFormat(value: string): boolean {
    const formatRegex = /^\d{8}\.\d{1}\.\d{1}$/;
    return formatRegex.test(value);
  }
  
  onSubmit(recordStatus: any) {
    if (this.IsLoadingResults) {
      return;
    }
    var recordStatusName = '';
   
    //2. Generic Mandatory Validation Message - INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
    if (recordStatus == 2 && !this.GTCForm.valid) {
      this.showValidationSummary = true;
      this.showErrorsOnInvalidForm();
    }
    //2. Generic Mandatory Validation Message - INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
    // 1. Save as Draft – Record Not Visible - INTAXGTC Defect - By Shipra Mam 
    //Changes Allow After discussed with Ismail and Shipra Mam 
    if (recordStatus == 1) {
      if (this.checkValueIsNullOrEmptyOrUndefined(this.getFormControls('FirmId').value)
        || this.checkValueIsNullOrEmptyOrUndefined(this.getFormControls('PaceID').value)) {
        alert('Please fill both Contracting Member Firm and Pace ID before saving as draft.');
        return;
      }
    }
    // 1. Save as Draft – Record Not Visible - INTAXGTC Defect - By Shipra Mam 

    if (this.isValidPaceIdFormat(this.getFormControls('PaceID').value) == false) {
      alert('Please enter valid Pace ID in format 12345678.1.1');
      return;
    }

    if (recordStatus == 2) {
      if (!this.GTCForm.valid) {
        alert('Please fill in all required fields before submitting for approval.');
        this.getInvalidControlsWithValues(this.GTCForm)
        return;
      }
      var IsGTCApprovedGCO = this.GTCForm.controls['IsGTCApprovedGCO'].value;
      if (!this.checkValueIsNullOrEmptyOrUndefined(IsGTCApprovedGCO)) {

        //7. Deleted Clause Validation Missing -- Changes done by Rehan -- INTaxGTC Defect  By Shipra Mam
        const activeClauseCount = (this.ClauseViewList || []).filter((clause: any) => clause.IsActive !== false).length;
        if (this.global.IsEngTeam && IsGTCApprovedGCO == 1 && activeClauseCount == 0) {
          alert('Please add clause first to submit record.');
          return;
        }
        //7. Deleted Clause Validation Missing -- Changes done by Rehan -- INTaxGTC Defect  By Shipra Mam
        if (IsGTCApprovedGCO == 1 && this.ClauseViewList.length == 0) {
          alert('Please add clause details for this entry.');
          return;
        }
      }
    }

    if (recordStatus == 1) {
      recordStatusName = 'Draft'
    }
    else if (recordStatus == 2) {
      recordStatusName = 'Pending By TQ Team'

    }
    else if (recordStatus == 3) {
      recordStatusName = 'Pending By TQ Leader'

    }
    else if (recordStatus == 4) {
      recordStatusName = 'Approved'

    }
    else if (recordStatus == 5) {
      recordStatusName = 'Rejected'

    }
    else if (recordStatus == 6) {
      recordStatusName = 'Returned'

    }
    if (this.IsConsentFalse && recordStatus == 2) {
      alert('Please consult with GCO team and share their review comments on the proposed edits , You are not allowed to submit the record as C3 is selected No');
      return;
    }
    
    if (recordStatus == 2 && this.ClauseViewList.length > 0) {
      this.resetClausesForTQReview();
    }
    
    this.GTCForm.patchValue({
      RecordStatus: recordStatus,
      StatusName: recordStatusName,
      AttachmentList: this.AttachDict.length > 0 ? this.AttachDict : this.getFormControls('AttachmentList').value,
      ClauseViewList: this.ClauseViewList.length > 0 ? this.ClauseViewList : this.getFormControls('ClauseViewList').value,
      ExceptionalCategory: this.SelectedExceptionalDetails.toString().length > 0 ? this.SelectedExceptionalDetails.toString() : this.getFormControls('ExceptionalCategory').value
    });

    if (!this.checkValueIsNullOrEmptyOrUndefined(this.modifiedClauseViewList)) {
      this, this.GTCForm.patchValue({
        ClauseViewList: this.modifiedClauseViewList
      })
    }
    this.IsFormEditable = false;
    this.IsLoadingResults = true;
    if (this.IsCopyRedirected) {
      this.getFormControls('RequestEntityId').reset();
      this.getFormControls('RequestEntityId').updateValueAndValidity();
    }
    let EngPartnerName = this.getFormControls('EngPartnerName').value;
    if (!this.checkValueIsNullOrEmptyOrUndefined(EngPartnerName)) {
      this.getFormControls('EngPartnerName').setValue(EngPartnerName.EmpName);
      this.getFormControls('EngPartnerGPN').setValue(EngPartnerName.EmpGPN);
    }   
    else {
      this.getFormControls('EngPartnerName').setValue(null);
      this.getFormControls('EngPartnerGPN').setValue(null);
    }

    let EngManagerName = this.getFormControls('EngManagerName').value;
    if (!this.checkValueIsNullOrEmptyOrUndefined(EngManagerName)) {
      this.getFormControls('EngManagerName').setValue(EngManagerName.EmpName);
      this.getFormControls('EngManagerGPN').setValue(EngManagerName.EmpGPN);
    }
     else {
      this.getFormControls('EngManagerName').setValue(null);
      this.getFormControls('EngManagerGPN').setValue(null);
    }
    if (this.checkValueIsNullOrEmptyOrUndefined(this.getFormControls('RequestEntityId').value)) {
      this.status.setHttpStatus(true);
      this._gtcService.saveOrUpdateGTCRequest(this.getGTCRequestPayload(), 'Insert').subscribe((data: any) => {
        console.log('[A7.1 Trace] Insert API response:', data);
        alert(data.RequestMessage);
        if (data.RequestIsSuccess) {
          this.IsLoadingResults = false;

          //this.messageService.add({ severity: 'success', summary: 'Success Message', detail: data.RequestMessage });
          this.getFormControls('RecordStatus').setValue(recordStatus);
          if (this._router.url.trim() == 'home/createRequistion/edit/' + data.RequestEntityId) {
            this.GetGTCRequestById(data.RequestEntityId, false);
          } else {
            this._router.navigate(['home/createRequistion/edit/' + data.RequestEntityId]);

          }
        } else {
          this.IsFormEditable = true;
          this.IsLoadingResults = false;

          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data.RequestMessage });
        }
        this.IsLoadingResults = false;

      }, (error: HttpErrorResponse) => {
        var d = error;
        this.IsLoadingResults = false;

        this.status.setHttpStatus(false);
      },
        () => {
          this.IsLoadingResults = false;
          this.status.setHttpStatus(false);
        });
    }
    else {

      this.status.setHttpStatus(true);
      this._gtcService.saveOrUpdateGTCRequest(this.getGTCRequestPayload(), 'Update').subscribe((data: any) => {
        console.log('[A7.1 Trace] Update API response:', data);
        alert(data.RequestMessage);
        if (data.RequestIsSuccess) {
          this.getFormControls('RecordStatus').setValue(recordStatus);
          if (this._router.url.trim() == 'home/createRequistion/edit/' + data.RequestEntityId) {
            this.GetGTCRequestById(data.RequestEntityId, false);
          } else {
            this._router.navigate(['/home/MyRequisition/1']);
          }
        } else {
          this.getFormControls('RecordStatus').setValue('1');
          this.IsFormEditable = true;
          // this.showErrorsOnInvalidForm();
          //this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data.RequestMessage });
        }
        this.IsLoadingResults = false;

      }, (error: any) => {
        this.IsLoadingResults = false;
        var errord = error;
        this.status.setHttpStatus(false);
      },

        () => {
          this.IsLoadingResults = false;
          this.status.setHttpStatus(false);
        });
    }


  }
  private getGTCRequestPayload(): any {
    const payload = { ...this.GTCForm.value };
    const engPartnerReqName = payload.EngPartnerReqName;

    if (engPartnerReqName && typeof engPartnerReqName === 'object') {
      payload.EngPartnerReqName = this.getEmployeePartnerValue(engPartnerReqName);
    }

    return payload;
  }

  private resetClausesForTQReview(): void {
    const clauses = this.ClauseViewList.flatMap((item: any) => item.ClauseDetailsList || []);

    clauses.forEach((clause: any) => {
      const isNewClause = this.checkValueIsNullOrEmptyOrUndefined(clause.ClauseGTCID);
      const isNonApprovedReviewStatus = !this.checkValueIsNullOrEmptyOrUndefined(clause.ClauseStatus)
        && clause.ClauseStatus != 1;
      const isEditedApprovedClause = clause.ClauseStatus == 1 && clause.IsEditedByRequestor === true;

      if (isNewClause || isNonApprovedReviewStatus || isEditedApprovedClause) {
        clause.ClauseStatus = null;
      }

      delete clause.IsEditedByRequestor;
    });
  }

  ExportClauses() {
    this.IsLoadingResults = true;
    // Use live ClauseViewList (updated after "Done") if available, otherwise fall back to saved/form data
    let clauseList = this.ClauseViewList.length > 0 ? this.ClauseViewList :
      (this.savedClauseViewList.length > 0 ? this.savedClauseViewList : this.getFormControls('ClauseViewList').value);
    if (this.checkValueIsNullOrEmptyOrUndefined(clauseList)) {
      this.IsLoadingResults = false;

      alert('No clauses to export');
      return;

    }
    let allSubLists = clauseList.map((clause: any) => clause.ClauseDetailsList);
    let combinedList = allSubLists.flat();
    this.clientDetails.GTCID = this.GTCNo; //this.getFormControls('ClauseViewList').value[0].GtcID;
    this.clientDetails.ClientName = this.GTCForm.controls['ClientName'].value;
    let filterlist = combinedList.filter((x: any) => x.ClauseRadioType == '1' || x.ClauseRadioType == '2' || x.ClauseRadioType == '4');
    // TQ Comments visibility rules:
    // - Final status (4/5/6/7): TQ Comments visible for everyone
    // - Non-final status: TQ Comments visible only if TQ Approver/Admin clicked Done (modified comments)
    const isFinalStatus = this.RecordStatus == 4 || this.RecordStatus == 5 || this.RecordStatus == 6 || this.RecordStatus == 7;
    const isTQApproverOrAdmin = this.global.IsTQApprover || this.global.IsAdmin || this.global.IsTQLeader;
    if (!isFinalStatus && !(isTQApproverOrAdmin && this.isTQCommentsModified)) {
      filterlist = filterlist.map((clause: any) => ({ ...clause, TQComments: '' }));
    }
    const request = {
      gtcRequestId: this.clientDetails.GTCID,
      clientName: this.clientDetails.ClientName,
      clauseMasterDTO: filterlist
    };

    this._dataService.DownloadFileWithPost('TaxGTC/ExportToExcelClauses', request).subscribe((x: BlobPart) => {

      const data = new Blob([x], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      saveAs(data, this.GTCNo + '.docx');


    }, (error: any) => {

      this.IsLoadingResults = false;
      // this.status.setHttpStatus(false);
      error.handleError(error);
    });
    this.IsLoadingResults = false;
  }

  onExistingClientSelectedOrNot(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event.value)) {
      if (event.value == 2) {
        this.IsAcptForChangesInPast = true;
        this.getFormControls('IsAcceptanceForChangesInPast').setValidators([Validators.required]);
        this.getFormControls('IsAcceptanceForChangesInPast').updateValueAndValidity();
        if (!this.checkValueIsNullOrEmptyOrUndefined(this.RequestEntityId)) {
          this.getFormControls('PushBackAttachment').setValidators([Validators.required]);
        } else {
          this.getFormControls('PushBackAttachment').clearValidators();
        }
        this.getFormControls('PushBackAttachment').updateValueAndValidity();


      }
      else if (event.value == 1) {
        this.IsChangesInPast = false;
        this.getFormControls('IsAcceptanceForChangesInPast')?.reset();
        this.IsAcptForChangesInPast = false;
        this.getFormControls('IsAcceptanceForChangesInPast').clearValidators();
        this.getFormControls('IsAcceptanceForChangesInPast').updateValueAndValidity();
        this.removeAttachment('ApprDtlForTaxQualityLOLAttachment');
        this.getFormControls('ApprDtlForTaxQualityLOL').setValue('');
        this.getFormControls('ApprDtlForTaxQualityLOLAttachment').clearValidators();
        this.getFormControls('ApprDtlForTaxQualityLOLAttachment').updateValueAndValidity();
        this.getFormControls('ApprDtlForTaxQualityLOL').clearValidators();
        this.getFormControls('ApprDtlForTaxQualityLOL').updateValueAndValidity();
        this.getFormControls('PushBackAttachment').setValidators([Validators.required]);
        this.getFormControls('PushBackAttachment').updateValueAndValidity();
      }
      else {
        return;
      }
    }

  }

  removeAttachment(value: string) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(this.AttachDict)) {
      // Remove all entries with matching Key (supports multiple files per field)
      this.AttachDict = this.AttachDict.filter((element: any) => element.Key !== value);
      this.GTCForm.controls[value].setValue('');
    }
  }
  onChangesInPast(event: any) {

    if (!this.checkValueIsNullOrEmptyOrUndefined(event.value)) {
      if (event.value == 1 || event.value == 3) {
        this.IsChangesInPast = true;
        this.getFormControls('ApprDtlForTaxQualityLOLAttachment').setValidators([Validators.required]);
        this.getFormControls('ApprDtlForTaxQualityLOLAttachment').updateValueAndValidity();
        this.getFormControls('ApprDtlForTaxQualityLOL').setValidators([Validators.required, this.customValidators.nameValidator]);
        this.getFormControls('ApprDtlForTaxQualityLOL').updateValueAndValidity();
      }
      else if (event.value == 2) {

        this.removeAttachment('ApprDtlForTaxQualityLOLAttachment');
        this.IsChangesInPast = false;
        this.getFormControls('ApprDtlForTaxQualityLOLAttachment').clearValidators();
        this.getFormControls('ApprDtlForTaxQualityLOLAttachment').updateValueAndValidity();
        this.getFormControls('ApprDtlForTaxQualityLOL').clearValidators();
        this.getFormControls('ApprDtlForTaxQualityLOL').updateValueAndValidity();
        this.getFormControls('ApprDtlForTaxQualityLOL').setValue('');
      }
      else {
        return;
      }
    }

  }


  GetGTCRequestById(requestId: any, value: any) {
    this.status.setHttpStatus(true);
    this.IsLoadingResults = true;

    if (!this.checkValueIsNullOrEmptyOrUndefined(requestId)) {
      this._gtcService.GetGTCRequest(requestId, value).subscribe(data => {
        console.log('[A7.1 Trace] Get details API response:', {
          recordStatus: data.RecordStatus ?? data.recordStatus,
          EngPartnerReqName: data.EngPartnerReqName,
          RequiredEmpPartnerGPN: data.RequiredEmpPartnerGPN,
          IsPartnerNameRequired: data.IsPartnerNameRequired
        });
        var d = data;
        const loadedPartnerValue = data.EngPartnerReqName ?? data.RequiredEmpPartnerGPN;
        this.GTCForm.patchValue({
          RecordStatus: data.recordStatus,
          FirmId: data.FirmID != null ? String(data.FirmID) : data.FirmID,
          SSL: data.SSL,
          Location: data.Location,
          ClientName: data.ClientName,
          PaceID: data.PACEID,
          IsIndependenceRestrictedClient: data.IsIndependenceRestrictedClient != null ? String(data.IsIndependenceRestrictedClient) : data.IsIndependenceRestrictedClient,
          IsG360Client: data.IsG360Client != null ? String(data.IsG360Client) : data.IsG360Client,
          IsClientNew: data.IsClientNew != null ? String(data.IsClientNew) : data.IsClientNew,
          PushBackDone: data.PushBackDone,
          IsAcceptanceForChangesInPast: data.IsAcceptanceForChangesInPast != null ? String(data.IsAcceptanceForChangesInPast) : data.IsAcceptanceForChangesInPast,
          ApprDtlForTaxQualityLOL: data.ApprDtlForTaxQualityLOL,
          IsGTCApprovedGCO: data.IsGTCApprovedGCO != null ? String(data.IsGTCApprovedGCO) : data.IsGTCApprovedGCO,
          BusinessCaseAcceptanceReason: data.BusinessCaseAcceptanceReason,
          IsGTCProposedForEAOrMSA: data.IsGTCProposedForEAOrMSA != null ? String(data.IsGTCProposedForEAOrMSA) : data.IsGTCProposedForEAOrMSA,
          TaxExclusiveForMSA: data.TaxExclusiveForMSA != null ? String(data.TaxExclusiveForMSA) : data.TaxExclusiveForMSA,
          TenureInMonths: data.TenureInMonths,
          ScopeOfWorkInBrief: data.ScopeOfWorkInBrief,
          AttachmentList: data.AttachmentList,
          RiskProfileEngagement: data.RiskProfileEngagement != null ? String(data.RiskProfileEngagement) : data.RiskProfileEngagement,
          DetailsOfRiskInvolvedInEng: data.DetailsOfRiskInvolvedInEng,
          ExpectedFeesFromClient: data.ExpectedFeesFromClient,
          ExpectedFeesFromClientForTaxServices: data.ExpectedFeesFromClientForTaxServices,
          LimitationOfLibality: data.LimitationOfLibality != null ? String(data.LimitationOfLibality) : data.LimitationOfLibality,
          Confidentiality: data.Confidentiality != null ? String(data.Confidentiality) : data.Confidentiality,
          Indemnity: data.Indemnity != null ? String(data.Indemnity) : data.Indemnity,
          IsExceptionalApprovalRequired: data.IsExceptionalApprovalRequired != null ? String(data.IsExceptionalApprovalRequired) : data.IsExceptionalApprovalRequired,
          ExceptionalDetails: data.ExceptionalDetails,
          ClauseViewList: data.ClauseViewList,
          ClientID: data.ClientID,
          EngPartnerGPN: data.EngPartnerGPN,
          EngManagerGPN: data.EngManagerGPN,
          RequiredEmpPartnerGPN: data.RequiredEmpPartnerGPN,
          EngPartnerReqName: loadedPartnerValue ? { extraLabel: loadedPartnerValue } : null,
          IsPartnerNameRequired: data.IsPartnerNameRequired != null ? String(data.IsPartnerNameRequired) : data.IsPartnerNameRequired,
          PaceIdMessage: data.PaceIdMessage,
        });
        console.log('[A7.1 Trace] After patchValue:', {
          EngPartnerReqName: this.getFormControls('EngPartnerReqName').value,
          RequiredEmpPartnerGPN: this.getFormControls('RequiredEmpPartnerGPN').value
        });
        this.IsLoadingResults = false;
        // this.PartnerList = [{ EmpGPN: data.EngPartnerGPN, EmpName: data.EngPartnerName }];
        // this.ManagerList = [{ EmpGPN: data.EngManagerGPN, EmpName: data.EngManagerName }];
        // this.getFormControls('EngPartnerName').setValue(this.PartnerList[0]);
        // this.getFormControls('EngManagerName').setValue(this.ManagerList[0]);
        //  this.AttachDict=    this.getFormControls('AttachmentList').value

        
        this.PartnerList = data.EngPartnerName
          ? [{ EmpGPN: data.EngPartnerGPN, EmpName: data.EngPartnerName }]
          : [];

        this.ManagerList = data.EngManagerName
          ? [{ EmpGPN: data.EngManagerGPN, EmpName: data.EngManagerName }]
          : [];

        this.getFormControls('EngPartnerName').setValue(
          this.PartnerList.length ? this.PartnerList[0] : null
        );

        this.getFormControls('EngManagerName').setValue(
          this.ManagerList.length ? this.ManagerList[0] : null
        );


        if (!this.checkValueIsNullOrEmptyOrUndefined(data.ActionTakenByTQL)
          && !this.checkValueIsNullOrEmptyOrUndefined(data.ClauseViewList)) {
          this.IsTQLComments = true;
        }
        else {
          this.IsTQLComments = false;

        }

        this.RecordStatus = data.RecordStatus;


        if ((this.global.IsAdmin || this.global.IsTQApprover) && this.RecordStatus != 1) {
          this.IsExceptionalRequired = true;
          this.IsExceptionalScreenDisabled = false;
          this.getFormControls('IsExceptionalApprovalRequired').setValidators([Validators.required]);
          this.getFormControls('IsExceptionalApprovalRequired').updateValueAndValidity();
        }
        this.ShowApprovalButtons = data.ShowApprovalButtons;
        if (data.IsGTCApprovedGCO == 2) {
          this.IsShowattachGCOAttach = false;
          this.IsConsentFalse = true;
          //this.DisableAndRemoveValidatationsFileds();
        }
        else {
          this.IsConsentFalse = false;

          this.IsShowattachGCOAttach = true;
          //this.EnableAndAddValidatationsFileds();
        }
        //5. Mandatory Validation Not Triggered // INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
        this.updateAttachGCOAttachmentValidation();
        //5. Mandatory Validation Not Triggered // INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
        if (data.RiskProfileEngagement == 1 || data.RiskProfileEngagement == null) {
          // this.getFormControls('DetailsOfRiskInvolvedInEng').clearValidators();
          // this.getFormControls('DetailsOfRiskInvolvedInEng').updateValueAndValidity();
        } else {
          // this.getFormControls('DetailsOfRiskInvolvedInEng').setValidators([Validators.required,this.customValidators.nameValidator]);
          // this.getFormControls('DetailsOfRiskInvolvedInEng').updateValueAndValidity();

        }

        if (data.IsClientNew == 2) {

          this.IsAcptForChangesInPast = true;
          this.getFormControls('IsAcceptanceForChangesInPast').setValidators([Validators.required]);
          this.getFormControls('IsAcceptanceForChangesInPast').updateValueAndValidity();
          this.getFormControls('PushBackAttachment').setValidators([Validators.required]);
          this.getFormControls('PushBackAttachment').updateValueAndValidity();
        } else {
          this.IsChangesInPast = false;
          this.IsAcptForChangesInPast = false;
          this.getFormControls('IsAcceptanceForChangesInPast').clearValidators();
          this.getFormControls('IsAcceptanceForChangesInPast').updateValueAndValidity();
          this.getFormControls('PushBackAttachment').setValidators([Validators.required]);
          this.getFormControls('PushBackAttachment').updateValueAndValidity();

        }

        if (data.IsAcceptanceForChangesInPast == 1 || data.IsAcceptanceForChangesInPast == 3) {

          this.IsChangesInPast = true;
          this.getFormControls('ApprDtlForTaxQualityLOLAttachment').setValidators([Validators.required]);
          this.getFormControls('ApprDtlForTaxQualityLOLAttachment').updateValueAndValidity();
          this.getFormControls('ApprDtlForTaxQualityLOL').setValidators([Validators.required, this.customValidators.nameValidator]);
          this.getFormControls('ApprDtlForTaxQualityLOL').updateValueAndValidity();
        } else {
          this.removeAttachment('ApprDtlForTaxQualityLOLAttachment');
          this.IsChangesInPast = false;
          this.getFormControls('ApprDtlForTaxQualityLOLAttachment').clearValidators();
          this.getFormControls('ApprDtlForTaxQualityLOLAttachment').updateValueAndValidity();
          this.getFormControls('ApprDtlForTaxQualityLOL').clearValidators();
          this.getFormControls('ApprDtlForTaxQualityLOL').updateValueAndValidity();
          this.getFormControls('ApprDtlForTaxQualityLOL').setValue('');

        }
        if (data.IsGTCProposedForEAOrMSA == 2) {

          this.IsGTCProposed = true;
          this.getFormControls('TaxExclusiveForMSA').setValidators([Validators.required]);
          this.getFormControls('TaxExclusiveForMSA').updateValueAndValidity();
        } else {
          this.IsGTCProposed = false;
          this.getFormControls('TaxExclusiveForMSA').clearValidators();
          this.getFormControls('TaxExclusiveForMSA').updateValueAndValidity();

        }

        if (!this.checkValueIsNullOrEmptyOrUndefined(this.getFormControls('FirmId').value)) {
          let firmName = this.entityNameList.find((s: { value: any; }) => s.value == this.getFormControls('FirmId').value).label;
          this.getFormControls('FirmName').setValue(firmName);

        }
        this.SetLocalAttachmentList(data.AttachmentList, 'PushBackAttachment');
        this.SetLocalAttachmentList(data.AttachmentList, 'ApprDtlForTaxQualityLOLAttachment');
        this.SetLocalAttachmentList(data.AttachmentList, 'AttachGCOAttachment');
        this.SetLocalAttachmentList(data.AttachmentList, 'ScopeOfWorkInBriefAttachment');
        this.ClauseViewList = this.getFormControls('ClauseViewList').value;

        var count = 0;
        if (!this.checkValueIsNullOrEmptyOrUndefined(this.ClauseViewList)) {
          this.ClauseViewList.map((todo, i) => {
            count = count + 1
            this.ClauseViewList[i].PaceID = this.getFormControls('PaceID').value;
            this.ClauseViewList[i].EntityName = this.getFormControls('FirmName').value;
            this.ClauseViewList[i].GtcID = count
            this.ClauseViewList[i].IsActive = true
          });
        }
        this.savedClauseViewList = JSON.parse(JSON.stringify(this.ClauseViewList || []));

        this.FormStatusName = data.StatusName;
        this.GTCNo = data.GTCNumber;
        this.IsFormEditable = data.IsFormEditable;
        if (data.RecordStatus == 4 || data.RecordStatus == 5) {
          this.ShowButtons = false
          this.IsAddCluaseButtonShow = false;
          this.GTCForm.disable();
          this.IsDisableExpProp = true;
        }
        else if (data.RecordStatus == 2 || data.RecordStatus == 8) {
          this.IsAddCluaseButtonShow = false;
          this.GTCForm.disable();
          this.getFormControls('IsExceptionalApprovalRequired').enable();
          this.getFormControls('ExceptionalDetails').enable();
          this.ShowButtons = true
        }
        else if (data.RecordStatus == 6 || data.RecordStatus == 7 || data.RecordStatus == 9) {
          if (this.global.IsTQLeader || this.global.IsTQApprover) {
            this.IsReturnRequest = false;
            this.GTCForm.disable();
          } else {
            this.IsReturnRequest = true;

          }
          this.IsExceptionalRequired = false;
        }
        else if (data.RecordStatus == 3) {
          this.IsAddCluaseButtonShow = false;
          this.GTCForm.disable();
          this.IsDisableExpProp = true;
          this.IsFormEditable = false;
          this.IsReturnRequest = false;
        }
        else if (data.recordStatus == 1) {
          if (this.global.IsAdmin || this.global.IsTQApprover) {
            this.GTCForm.disable();
          }
        }

        if (data.RiskProfileEngagement == 2 || data.RiskProfileEngagement == 3) {
          this.IsRiskInvlovedTextBoxShown = true;
        }
        else {
          this.IsRiskInvlovedTextBoxShown = false;
        }
        if (!this.checkValueIsNullOrEmptyOrUndefined(data.ExceptionalCategory)) {
          let array = data.ExceptionalCategory.split(',');
          if (array.length > 0) {
            this.SetExpCatData(array);
          }
        }

        if (data.IsPartnerNameRequired == 1) {
          this.IsAddEngPartnerRequired = true;
          this.getFormControls('EngPartnerReqName').setValidators([Validators.required]);
          this.getFormControls('EngPartnerReqName').updateValueAndValidity();

        }
        //  if(data.RecordStatus == 2){
        //   this.GTCForm.disable();
        //  }
      });
    }
  }
  CancelRejectReturn(): void {
    this._dialog.closeAll();
  }
  onInputBlur($event: FocusEvent) {

    const inputElement = $event.target as HTMLInputElement;
    if (!this.checkValueIsNullOrEmptyOrUndefined(inputElement.value) && inputElement.value.length == 12) {
      this.IsLoadingResults = true
      this._commonService.BindDropDownWithParam('PACEDuplicate', inputElement.value).subscribe((result: any) => {

        if (result.length > 0) {
          alert('This PACE ID has been submitted by engagement team in the past.');
        }
        //this.GetAllGTCData();
        this.IsLoadingResults = false
      });
    }


  }
  navigateToPage() {
    // let clauseList =this.getFormControls('ClauseViewList').value;
    if (!this.checkValueIsNullOrEmptyOrUndefined(this.ClauseViewList)) {
      let allSubLists = this.ClauseViewList.map((clause: any) => clause.ClauseDetailsList);
      let combinedList = allSubLists.flat();
      this.OpenDialogForClauseChange("ClauseScreen", 23, [], true, combinedList);


    }
  }
  ChangeApprovalStatusWithReason(templateRef: any, actionId: any) {
    if (!this.validateApprovalActionPrerequisites()) {
      return;
    }

    this.SelectedAction = actionId;
    const dialogreturnRejectRequest = this._dialog.open(templateRef, {
      width: '750px',
      disableClose: true
      // data: { name: this.name, animal: this.animal }
    });
  }
  ChangeApprovalStatusForInitaialRequest(actionId: any) {
    this.IsLoadingResults = true;

    if (this.RecordStatus == 8) {
      this.IsLoadingResults = false;
      alert('The current record has already been initiated by the TQ Team.')
      return;
    }
    var approvalChange = {
      "RecordId": this.RequestEntityId,
      "CurrentStatus": actionId
    };




    this._gtcService.ChangeApprovalStatus(approvalChange).subscribe((data: any) => {

      alert(data.RequestMessage);


      this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this._router.navigate(['home/createRequistion/edit/' + this.RequestEntityId]);
      });


      this.IsLoadingResults = false;

    });


  }
  SendToTQL(templateRef: any, actionId: any) {
    if (!this.validateApprovalActionPrerequisites()) {
      return;
    }

    this.SelectedAction = actionId;
    const dialogreturnRejectRequest = this._dialog.open(templateRef, {
      width: '750px',
      disableClose: true
      // data: { name: this.name, animal: this.animal }
    });
  }
  SendToTQLWithReasons(SelectedAction: any) {
    var message = '';
    this.IsLoadingResults = true;

    if (SelectedAction === this.PendingWithTQL) {
      this.RecordStatus = 3
      this.IsLoadingResults = false;

      message = 'Are you sure you want to send the request to TQL?';
    }
    if ((SelectedAction === this.PendingWithTQL)
      && (this.SendTOTQLReson == null || this.SendTOTQLReson == undefined || this.SendTOTQLReson.replace(/\s/g, "") == "")) {
      this.IsLoadingResults = false;

      alert('Please enter TQComments');
      return;
    }
    var approvalChange = {
      "RecordId": this.RequestEntityId,
      "CurrentStatus": this.RecordStatus,
      "Remarks": this.SendTOTQLReson,
      "IsExceptionalApprovalRequired": this.GTCForm.controls['IsExceptionalApprovalRequired'].value,
      "ExceptionalDetails": this.GTCForm.controls['ExceptionalDetails'].value,
      "ExceptionalCategory": this.SelectedExceptionalDetails.toString().length > 0 ? this.SelectedExceptionalDetails.toString() : this.getFormControls('ExceptionalCategory').value,
      "ClauseList": this.ClauseViewList
    };
    if (!confirm(message)) {
      this.IsLoadingResults = false;


      return;
    }
    else {
      this.IsLoadingResults = false;

    }
    // if(!this.checkValueIsNullOrEmptyOrUndefined(this.getFormControls('PaceIdMessage').value)){

    //   this.IsLoadingResults = false;

    //   const confirmation = confirm(this.getFormControls('PaceIdMessage').value);
    //   if (confirmation) {
    //   } else {
    //     return;
    //   }
    // }
    this._dialog.closeAll();
    this.IsLoadingResults = true;

    this._gtcService.ChangeApprovalStatus(approvalChange).subscribe((data: any) => {

      alert(data.RequestMessage);

      if (data.RequestIsSuccess) {
        // this.hubConnection.invoke("RequestClosed", this.datas).catch(error => console.error(error));
        window.history.back();

      }
      this.IsLoadingResults = false;

    });
    return true;
  }
  onRemove(data: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(this.ClauseViewList)) {
      //7. Deleted Clause Validation Missing -- Changes done by Rehan -- INTaxGTC Defect  By Shipra Mam
      if (this.global.IsEngTeam && !confirm('Are you sure want to delete this clause?')) {
        return;
      }
      //7. Deleted Clause Validation Missing -- Changes done by Rehan -- INTaxGTC Defect  By Shipra Mam
      let indexToUpdate = this.ClauseViewList.findIndex(item => item.GtcID === data.GtcID);
      data.IsActive = false;
      this.ClauseViewList[indexToUpdate] = data;
      // var list = this.ClauseViewList
      // this.modifiedClauseViewList = this.ClauseViewList;

      // this.ClauseViewList.forEach((element, index) => {
      //   if (element.GtcID == data.GtcID) this.ClauseViewList.splice(index, 1);
      // });

      this.table.renderRows();
    }
  }
  visibleFn(element: any): boolean {
    var d = element.IsActive;
    return d;
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.GTCForm.controls).forEach((field: any) => {
      const control = this.GTCForm.get(field)!;
      control.markAsTouched({ onlySelf: true });


      const controlErrors: ValidationErrors = this.GTCForm.get(field)!.errors!;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + field + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }
  //2. Generic Mandatory Validation Message - INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
  getMissingRequiredFields(section: string): ValidationSummaryField[] {
    if (!this.showValidationSummary) {
      return [];
    }

    return (this.validationSummaryFields[section] || [])
      .filter(field => {
        const control = this.GTCForm.get(field.controlName);
        return this.isProposedChangesFieldVisible(field.controlName)
          && control?.enabled
          && control.hasError('required');
      })
      .map(field => ({
        ...field,
        label: this.getValidationSummaryLabel(field)
      }));
  }

  isProposedChangesFieldVisible(controlName: string): boolean {
    switch (controlName) {
      case 'IsAcceptanceForChangesInPast':
        return this.IsAcptForChangesInPast;
      case 'ApprDtlForTaxQualityLOL':
      case 'ApprDtlForTaxQualityLOLAttachment':
        return this.IsChangesInPast;
      case 'AttachGCOAttachment':
        return this.IsShowattachGCOAttach;
      default:
        return true;
    }
  }

  private getValidationSummaryLabel(field: ValidationSummaryField): string {
    if (field.controlName === 'IsGTCApprovedGCO') {
      return `${this.IsAcptForChangesInPast ? 'C3.' : 'C2.'} ${field.label}`;
    }

    if (field.controlName === 'AttachGCOAttachment') {
      return `${this.IsAcptForChangesInPast ? 'C3.1.' : 'C2.1.'} ${field.label}`;
    }

    if (field.controlName === 'BusinessCaseAcceptanceReason') {
      return `${this.IsAcptForChangesInPast ? 'C4.' : 'C3.'} ${field.label}`;
    }

    return field.label;
  }
  //2. Generic Mandatory Validation Message - INTAXGTC Defect - By Shipra Mam // Changes done by Rehan
  getInvalidControlsWithValues(form: FormGroup): { [key: string]: any } {
    const invalidControls: { [key: string]: any } = {};

    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);

      // Check if the control is invalid
      if (control && control.invalid) {
        // Add the control name and its value to the invalidControls object
        invalidControls[key] = control.value;
      }
    });

    return invalidControls;
  }
  SetExpCatData(array: any) {
    for (let i = 0; i < array.length; i++) {
      if (array[i] == 1) {
        this.IsIndirectDamages = true;
      } if (array[i] == 2) {
        this.IsDirectDamages = true;
      } if (array[i] == 3) {
        this.IsUnlimitedLiability = true;
      } if (array[i] == 4) {
        this.IsMutualLiability = true;
      } if (array[i] == 5) {
        this.IsDeletionIndemnity = true;
      } if (array[i] == 6) {
        this.IsCappingOfIndemnity = true;
      } if (array[i] == 7) {
        this.IsReciprocalLimitation = true;
      } if (array[i] == 8) {
        this.IsPerpetualConfidentiality = true;
      } if (array[i] == 9) {
        this.IsIncreaseConfidentiality = true;
      } if (array[i] == 10) {
        this.IsDual = true;
      } if (array[i] == 11) {
        this.IsOthers = true;
      }
    }
  }
  SetLocalAttachmentList(attacymentList: any, fieldName: string) {
    if (attacymentList.length > 0) {
      attacymentList.filter((x: any) => x.Key !== fieldName).forEach((x: any) => {
        this.getFormControls(fieldName).setValue('');
      });
      attacymentList.filter((x: any) => x.Key === fieldName).forEach((x: any) => {
        const a: any[] = [];
        x.Value.forEach((y: any) => {
          a.push(y);
        });
        if (a.length > 0) {
          this.getFormControls(fieldName).setValue(a);
        }
      });
    } else {
      this.getFormControls(fieldName).setValue('');
    }
  }
  getFormControls(controlName: any) {
    return this.GTCForm.controls[controlName];
  }
  OnAddClauseClicked() {
    var pace = this.getFormControls('PaceID').value;
    var firm = this.getFormControls('FirmId').value;
    if (!this.checkValueIsNullOrEmptyOrUndefined(pace) && !this.checkValueIsNullOrEmptyOrUndefined(firm)) {
      this.OpenDialogForClauseChange("ClauseScreen", 23, this.ClauseViewList, false);
    }
    else {
      alert('Please select Entity and Pace value to continue');
      return;
    }
  }
  onClauseNavigate(event: any) {
    var clauseData = this.ClauseViewList.filter(s => s.ClauseNo == event);
    this.OpenDialogForClauseChange("ClauseScreen", 23, clauseData, true, null);
  }
  OpenDialogForClauseChange(name: string, count: number, clauseList: any, IsSingleValue: boolean
    , CombineListOfData?: Array<any> | null) {
    // Deep copy clause data to prevent changes from affecting parent until "Done" is clicked
    const clauseListCopy = JSON.parse(JSON.stringify(clauseList));
    const combineListCopy = CombineListOfData ? JSON.parse(JSON.stringify(CombineListOfData)) : null;
    const dialogRef = this._dialog.open(AddClauseComponent,
      {
        disableClose: true,
        width: '80%',
        height: '90%',
        data: {
          fieldName: name, Count: count,
          FirmID: this.GTCForm.controls['FirmId'].value,
          IsFormEditable: this.IsFormEditable,
          IsShownApprovalButtons: this.ShowApprovalButtons,
          ClauseList: clauseListCopy,
          IsSingleValue: IsSingleValue,
          CombineListOfData: combineListCopy,
          RecordStatus: this.RecordStatus,
          IsNewRequest: this.checkValueIsNullOrEmptyOrUndefined(this.RequestEntityId)

        }
      });
    document.body.classList.add("cdk-global-scrollblock");
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        result = sortArrayOfObjects(result, "ClauseNumber", "ascending");
        if (this.global.IsTQApprover || this.global.IsAdmin || this.global.IsTQLeader) {
          this.isTQCommentsModified = true;
        }
        var clauseKey = 'Clause ' + result[0].ClauseNumber.toString() + '-' + result[(result.length - 1)].ClauseNumber.toString();
        this.ClauseDetailsList.push({
          'Key': clauseKey,
          'Value': result,
        });
        const now = new Date();
        // Check for existing record using trim and case-insensitive comparison
        var existingRecordIndex = this.ClauseViewList.findIndex(s => 
          s.ClauseNo?.trim().toLowerCase() == clauseKey.trim().toLowerCase()
        );
        if (existingRecordIndex >= 0) {
          this.ClauseViewList[existingRecordIndex].ClauseDetailsList = this.ClauseDetailsList[0].Value;
          this.ClauseViewList[existingRecordIndex].PaceID = this.getFormControls('PaceID').value;
          this.ClauseViewList[existingRecordIndex].EntityName = this.getFormControls('FirmName').value;
          this.ClauseViewList[existingRecordIndex].IsActive = true;
        } else {
          this.ClauseViewList.push({
            ClauseNo: clauseKey,
            PaceID: this.getFormControls('PaceID').value,
            EntityName: this.getFormControls('FirmName').value,
            CreatedOn: now.toLocaleDateString(),
            ClauseDetailsList: result,
            IsActive: true,
            GtcID: 0
          });

          var count = 0;
          this.ClauseViewList.map((todo, i) => {
            count = count + 1
            this.ClauseViewList[i].GtcID = count
          });
        }
        this.table.renderRows();
        this.ClauseDetailsList = [];
      }
      document.body.classList.remove("cdk-global-scrollblock");
    });
  }
  Exit() {
    if (confirm('Are you sure to exit?')) {
      //this.router.navigate(['dashboard']);
      window.history.back();
    }
  }

  OpenDialog(name: string, count: number, files: any) {

    // Retrieve existing attachment if it exists
    let isAttachmentEnable = false;
    let screenName = "CreateGTCRequest";
    if (name === 'ApproveWithTQCommentsAttachment') {
      isAttachmentEnable = true;
    }
    if (name === 'TQApproverAttachment') {
      isAttachmentEnable = true;
      screenName = "TQApproverAttachment";
    }
    let blobId = null;
    let blobIds: string[] = [];
    let existingAttachments = this.AttachDict?.filter((att: any) => att.Key === name) ?? [];
    if (existingAttachments.length === 0) {
      const attachmentList = this.getFormControls('AttachmentList').value;
      existingAttachments = attachmentList?.filter((att: any) => att.Key === name) ?? [];
    }

    existingAttachments.forEach((attachment: any) => {
      if (attachment.BlobIds?.length) {
        blobIds.push(...attachment.BlobIds);
      } else if (attachment.BlobId) {
        blobIds.push(attachment.BlobId);
      }
    });
    blobId = blobIds.length > 0 ? blobIds[0] : null;


    const dialogRef = this._dialog.open(FileUploadComponent,
      {
        disableClose: true,
        width: '40%',
        data: {
          fieldName: name, Count: count, Attachment: files,
          IsFormEditable: this.IsFormEditable, IsAttachmentEnable: isAttachmentEnable, ScreenName: screenName
          , BlobId: blobId, BlobIds: blobIds
        }
      });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        // Remove existing entries for this field
        this.AttachDict = this.AttachDict.filter((x: { Key: any; }) => x.Key !== result.fieldName);
        
        // Store each file with its own BlobId (supports multiple file upload)
        if (result.LocalAttachments && result.LocalAttachments.length > 0) {
          result.LocalAttachments.forEach((att: any) => {
            this.AttachDict.push({ 'Key': result.fieldName, 'Value': [att.FullName], 'BlobId': att.BlobId });
          });
        } else if (result.Attachment && result.Attachment.length > 0) {
          // Fallback for single file or old format
          this.AttachDict.push({ 'Key': result.fieldName, 'Value': result.Attachment, 'BlobId': result.BlobId });
        }
        
        this.GTCForm.patchValue({
          [result.fieldName]: result.Attachment
        });
      }
    });
  }
  radioButtonChange(event: any) {
    var selectedValue = event.value;
    if (!this.checkValueIsNullOrEmptyOrUndefined(selectedValue)) {
    }
  }
  ResetPaceDetails() {
  }
  getPaceDetails(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event)) {
      this.IsLoadingResults = true;

      this._dataService.get('TaxGTC/GetPaceIdDetails', event).subscribe((data: any) => {

        if (!this.checkValueIsNullOrEmptyOrUndefined(data)) {
          this.getFormControls('SSL').setValue(data[0].SSL);
          this.getFormControls('Location').setValue(data[0].Location);
          this.getFormControls('ClientName').setValue(data[0].EngClientName);
          this.getFormControls('EngPartnerName').setValue(data[0].EPName);
          this.getFormControls('EngManagerName').setValue(data[0].EMName);
          this.getFormControls('EngPartnerGPN').setValue(data[0].EPGPN);
          this.getFormControls('EngManagerGPN').setValue(data[0].EMGPN);
          this.getFormControls('ClientID').setValue(data[0].ENGClientID);
          if (!this.checkValueIsNullOrEmptyOrUndefined(data[0].Message) && this.RecordStatus == 1) {
            this.IsLoadingResults = false;

            alert(data[0].Message);
            return;
          }

        }
      }
      ), (error: any) => {
        this.IsLoadingResults = false;

      };
      this.IsLoadingResults = false;

    }
  }
  SearchPace(event: any) {
    this._commonService.BindDropDownForPaceValues(event.query).
      subscribe((result: any) => {
        this.paceList = result.map((a: { ENGCode: any; }) => a.ENGCode);
      });
  }
  SearchPartner(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event.query)) {
      if (this.global.containsSpecialChars(event.query)) {
        this.getFormControls('EngPartnerReqName')?.reset();
        alert("Please enter valid input")
        return;
      } else {

        this._commonService.BindDropDownWithParam('PartnerDetails', event.query, this.getFormControls('FirmId').value).
          subscribe((result: any) => {
            this.EmpPartnerList = result
            this.ref.detectChanges();
          });
      }

    }

  }
  setPartnerGPN(event: any) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event)) {
      this.getFormControls('RequiredEmpPartnerGPN').setValue(this.getEmployeePartnerValue(event));
    }
  }

  private getEmployeePartnerValue(selection: EmployeePartnerSelection): string | null {
    const selectedPartner = selection.value && typeof selection.value === 'object'
      ? selection.value
      : selection;

    return selectedPartner.extraLabel ?? selectedPartner.label ??
      (typeof selectedPartner.value === 'string' ? selectedPartner.value : null);
  }
  checkValueIsNullOrEmptyOrUndefined(value: any) {
    if (value == null || value == undefined || value == "") {
      return true;
    }
    else {
      return false;
    }
  }
}
export class ClauseMasterDetails {
  firmId: any;
  clauseType: any;
  clauseNumber: any;
  description: any;
  createdBy: any;
}

export interface ClauseViewList {
  GtcID?: number;
  ClauseNo?: string;
  PaceID?: string;
  EntityName?: string;
  IsActive?: boolean;
  CreatedOn?: string;
  ClauseDetailsList?: Array<any>;
  ClauseStatus?: number;
}

export class ClientDetails {
  GTCID: any = '';
  ClientName: string = '';
}

const sortArrayOfObjects = <T>(
  data: T[],
  keyToSort: keyof T,
  direction: 'ascending' | 'descending' | 'none',
) => {
  if (direction === 'none') {
    return data
  }
  const compare = (objectA: T, objectB: T) => {
    const valueA = objectA[keyToSort]
    const valueB = objectB[keyToSort]

    if (valueA === valueB) {
      return 0
    }

    if (valueA > valueB) {
      return direction === 'ascending' ? 1 : -1
    } else {
      return direction === 'ascending' ? -1 : 1
    }
  }

  return data.slice().sort(compare)
}
